var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTireIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.09 23.662C8.888 26.157 7.384 27.358 6 27.358h11.829c3.408 0 6.171-5.97 6.171-13.334S21.237.692 17.83.692H6c1.385 0 2.889 1.201 4.09 3.697 1.168 2.43 1.91 5.836 1.91 9.636 0 3.8-.742 7.207-1.91 9.636z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.911 4.389C.742 6.819 0 10.225 0 14.025c0 3.8.742 7.207 1.911 9.636 1.2 2.496 2.704 3.697 4.089 3.697 1.385 0 2.889-1.2 4.09-3.697 1.168-2.43 1.91-5.836 1.91-9.636 0-3.8-.742-7.206-1.91-9.636C8.888 1.893 7.384.692 6 .692c-1.385 0-2.889 1.201-4.089 3.697zm1.839 9.636c0 4.651 1.007 8.421 2.25 8.421 1.147 0 2.094-3.214 2.233-7.368H6.75c-.621 0-1.125-.471-1.125-1.053 0-.581.504-1.053 1.125-1.053h1.483C8.094 8.82 7.147 5.604 6 5.604c-1.243 0-2.25 3.77-2.25 8.421z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTireIcon);
export default __webpack_public_path__ + "static/media/TireIcon.9c9480209fb63acc1d57c6b45b22b42f.svg";
export { ForwardRef as ReactComponent };